<div class="about-page">

  <h1>About Us</h1>

  <p class="subtitle">
    Tell customers about your business story and speciality
  </p>





  <!-- DISPLAY MODE -->

  <div
  class="about-card"
  *ngIf="!isEditMode && aboutData">


    <div class="card-header">

      <h2>
        About Your Business
      </h2>

      <button
      class="edit-btn"
      (click)="editAbout()">

        Edit

      </button>

    </div>



    <div class="display-section">

      <label>
        Business Story
      </label>

      <p>

        {{aboutData.story}}

      </p>

    </div>




    <div class="display-section">

      <label>
        Speciality
      </label>

      <p>

        {{aboutData.speciality}}

      </p>

    </div>


  </div>







  <!-- FORM -->

  <div
  class="about-card"
  *ngIf="isEditMode">


    <form
    [formGroup]="aboutForm"
    (ngSubmit)="saveAbout()">


      <div class="form-group">

        <label>
          Business Story
        </label>

        <textarea
        formControlName="story">

        </textarea>

      </div>




      <div class="form-group">

        <label>
          Speciality
        </label>

        <textarea
        formControlName="speciality">

        </textarea>

      </div>




      <div class="button-group">

        <button type="submit">

          {{loading?'Saving...':'Save Changes'}}

        </button>


        <button
        type="button"
        class="cancel-btn"
        (click)="cancelEdit()">

          Cancel

        </button>

      </div>


    </form>


  </div>


</div>